import { has } from "../../../../../utils/menu-context";
import store from "../../../../../store";
import { commonInputPropField } from "../license/request-license.condition";

export const createConditionAction = () => {
    let myRoleName = []
    store.state.resource.auth.info?.roles.forEach(userRole => {
        myRoleName.push(userRole.refRole.name)
    })

    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (record.createBy === store.state.resource.auth.info.user?.username) {
                if ([undefined, "draft", "waitModify"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forReviewRequest" })) {
                if (["waitAcceptRequest"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forLawyerAuditor" })) {
                if (["waitLawyerAudit"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forDofCenter" })) {
                if (["waitDofCenterAudit"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forAuthorized" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canArchive: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canArchive" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },

        canWaitFisheryOfficer: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" })) {
                if (record.createBy === store.state.resource.auth.info?.user?.username && !record.isOfficerCreate) {
                    if (["draft", "waitModify"].includes(record.refStatus?.key)) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canConfirmResult: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            // const userInfo = store.state.resource.auth.info?.user;
            if (record.isActive === false) return false;
            if (has({ menuContext, key: "forReviewRequest" })) {
                if (["waitAcceptRequest"].includes(record.refStatus?.key) && record.refFisheriesOfficerStatus != null ) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forLawyerAuditor" })) {
                if (["waitLawyerAudit"].includes(record.refStatus?.key) && record.refLawyerStatus != null) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forRDAuditor" })) {
                if (["waitRDAudit"].includes(record.refStatus?.key) && record.refRdStatus != null) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forDofCenter" })) {
                if (["waitDofCenterAudit"].includes(record.refStatus?.key) && record.refDofCenterStatus != null) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forAuthorized" }) && record.refDirectorStatus != null) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
    }
}

export const createConditionForm = () => {
    return [
        // Always disable input field
        {
            check: ({ field }) => {
                return [
                    "draftCode",
                    "requestCode",
                    "requestDate",
                    "refRequesterPersonType",
                    "requesterIdCard",
                    "refRequesterNationality",
                    "refVesselRequest.name",
                    "refVesselRequest.tgross",
                    "refVesselRequest.tnange",
                    "refVesselRequest.vesselType",
                    "refVesselRequest.useType",
                    "refVesselRequest.licenseIssueDate",
                    "refVesselRequest.licenseExpireDate",
                    "refVesselRequest.registrationDate",
                    "refVesselRequest.lbp",
                    "refVesselRequest.loa",
                    "refVesselRequest.deep",
                    "refVesselRequest.breadth",
                    "refVesselRequest.licenseNumber",
                    "labelWorker",
                    "isThaiWorkers",
                    "thaiMaleWorkers",
                    "thaiFemaleWorkers",
                    "isForeignWorkers",
                    "foreignMaleWorkers",
                    "foreignFemaleWorkers",
                    "totalThaiWorkers",
                    "totalForeignWorkers",
                    "refFishingArea",
                ].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            },
            checkboxField: () => {
                return { disabled: true };
            },
        },
        {
            check: ({ field }) => {
                return [
                    "requesterAge",
                    "requesterMobile",
                    "requesterEmail",
                ].includes(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: ["requestLicense", "requestLicense", "cancelLicense", "requestReplacement", "cancelLicense"]
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    if (common.disabled !== true) {
                        common.disabled = viewOnly ;
                    }
                } else if(!modelRef.isOfficerCreate) {
                    common.disabled = true;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refStatus",
                ].includes(field?.key);
            },
            visibleField: ({ data }) => {
                return ["EDIT_LICENSE_STATUS"].includes(data.roleEdit);
            },
            inputPropField: ({ props }) => {
                const { viewOnly } = props;
                const roleEdit = store.state.resource.auth.info?.roles.map((d) => d.refRole?.name).find((d) => d === "EDIT_LICENSE_STATUS");
                return { disabled: viewOnly || !roleEdit };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "changeStatusRemark",
                ].includes(field?.key);
            },
            visibleField: ({ data, modelRef }) => {
                return ["EDIT_LICENSE_STATUS"].includes(data.roleEdit) || !!modelRef.changeStatusRemark;
            },
            inputPropField: ({ props }) => {
                const { viewOnly } = props;
                const roleEdit = store.state.resource.auth.info?.roles.map((d) => d.refRole?.name).find((d) => d === "EDIT_LICENSE_STATUS");
                return { disabled: viewOnly || !roleEdit };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refOriginal.refFishingArea",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return (modelRef.refOriginal && ["moveAshore"].includes(modelRef.refChangeLicenseObjective?.key)) || false;
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refOriginal",
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef }) => {
                return { disabled: modelRef.id != null };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refReceiveDept",
                ].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitAcceptRequest", "waitModify", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                disabledRequestTypes: []
            }),
        },
        {
            check: ({ field }) => {
                return [
                    "licenseCode",
                    "refRequesterLifeStatus",
                    "requesterDeadDate"
                ].includes(field?.key);
            },
            visibleField: () => {
                return false;
            },
        },

        {
            check: ({ field }) => {
                return [
                    "refVesselRequest.code",
                ].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
            }),
            checkboxField: commonInputPropField({
                disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^refVesselRequest+\\.(attachmentVesselIdentities|attachmentPositionVesselIdentities|attachmentHeadVessels|attachmentFullVessels)\\.(exampleAttachment|dividerAttachment)\\.[^\\.]$`,
                    "g"
                ).test(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refOriginal;
            },
        },
        {
            check: ({ field }) => {
                const testReg = new RegExp(
                    `^refOriginal+\\.refVesselRequest+\\.(attachmentVesselIdentities|attachmentPositionVesselIdentities|attachmentHeadVessels|attachmentFullVessels)\\.(attachment)\\.[^\\.]$`,
                    "g"
                ).test(field?.key);
                return testReg
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refOriginal
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refVesselRequest.attachmentVesselIdentities",
                    "refVesselRequest.attachmentPositionVesselIdentities",
                    "refVesselRequest.attachmentHeadVessels",
                    "refVesselRequest.attachmentFullVessels",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef?.refOriginal;
            },
        },
        // Control การเห็น Field ตามประเภทบุคคล หรือ นิติบุคคล
        {
            check: ({ field }) => {
                return [
                    "refRequesterTitle",
                    "requesterFirstName",
                    "requesterFirstNameSpace",
                    "requesterLastName",
                    "refRequesterNationality",
                    "requesterAge",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refRequesterPersonType?.key == '2';
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refRequesterCompanyType",
                    "requesterName",
                    "requesterShareholdingTh",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refRequesterPersonType?.key == '1';
            },
        },
        // Disable when user is not officer
        {
            check: ({ field }) => {
                return [
                    "refRequesterPersonType",
                    "requesterName",
                    "refRequesterCompanyType",
                    "refRequesterTitle",
                    "requesterFirstName",
                    "requesterFirstNameSpace",
                    "requesterLastName",
                    "requesterAge",
                    "requesterMobile",
                    "requesterEmail",
                    "requesterShareholdingTh"
                ].includes(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: ["requestLicense", "cancelLicense", "transferLicense", "changeLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    if (common.disabled !== true) {
                        common.disabled = viewOnly ;
                    }
                } else if(!modelRef.isOfficerCreate) {
                    common.disabled = true;
                }

                return common;
            }
        },
        // Address
        {
            check: ({ field }) => {
                return new RegExp(
                    `^addresses\\.[^\\.]+\\.(refAddressType|fax|latitude|longitude|email|tel)$`,
                    "g"
                ).test(field?.key);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^addresses\\.[^\\.]+\\.(noTh|roomTh|buildingTh|floorTh|villageTh|mooTh|soiTh|roadTh|refProvince|refAmphur|refTambon|postCode)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: ["requestLicense", "cancelLicense", "requestReplacement", "cancelLicense"]
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    if (common.disabled !== true) {
                        common.disabled = viewOnly ;
                    }
                } else if(!modelRef.isOfficerCreate) {
                    common.disabled = true;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                const testReg = new RegExp(
                    `^attachments\\.[^\\.]+\\.(isVerify||isReject)$`,
                    "g"
                ).test(field?.key);
                return testReg;
            },
            visibleField: ({  modelRef }) => {
                let visible = false;
                if (["waitAcceptRequest", "waitModify", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"].includes(modelRef.refStatus?.key)) {
                    visible = true || visible;
                }
                return visible;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [undefined, "draft", "waitModify", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                disabledRequestTypes: ["requestLicense", "cancelLicense", "transferLicense", "changeLicense", "requestReplacement"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^attachments\\.[^\\.]+\\.(documentName|(attribute\\.(documentNo|documentDate|documentExpiredDate))|size)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                disabledRequestTypes: ["requestLicense", "cancelLicense", "transferLicense", "changeLicense", "requestReplacement"]
            })
        },
        {
            check: ({ field }) => {
                return [
                    "isCancelRequest",
                ].includes(field?.key);
            },
            visibleField: ({  modelRef }) => {
                let visible = false;
                if (![undefined, "draft"].includes(modelRef.refStatus?.key)) {
                    visible = true || visible;
                }
                return visible;
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const userInfo = store.state.resource.auth.info?.user;
                const common = commonInputPropField({
                    disabledStatuses: [undefined, "draft", "waitDofCenterAudit","waitApprove", "approve", "notApprove", "appeal", "cancel", "appeal"],
                    disabledRequestTypes: ["cancelLicense", "changeLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = (userInfo.username !== modelRef.createBy);
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "isCancelRequest",
                    "cancelRequestRemark",
                    "attachmentCancelRequests",
                ].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [undefined, "draft", "waitDofCenterAudit","waitApprove", "approve", "notApprove", "appeal", "cancel", "appeal"],
                disabledRequestTypes: ["requestLicense", "cancelLicense", "changeLicense", "transferLicense", "requestReplacement"]
            })
        },
        {
            check: ({ field }) => {
                return [
                    "cancelRequestRemark",
                    "attachmentCancelRequests",
                ].includes(field?.key);
            },
            visibleField: ({  modelRef }) => {
                let visible = false;
                if (modelRef.isCancelRequest) {
                    visible = true || visible;
                }
                return visible;
            },
        },
        // Case: Can view only officer create
        {
            check: ({ field }) => {
                return ["isAttorneySpace", "isAttorney"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficerCreate;
            },
            checkboxField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: ["cancelLicense", "changeLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    if (common.disabled !== true) {
                        common.disabled = viewOnly;
                    }
                } else if(!modelRef.isOfficerCreate) {
                    common.disabled = true;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refAttorneyTitle",
                    "attorneyFirstName",
                    "attorneyFirstNameSpace",
                    "attorneyLastName",
                    "attorneyIdCard",
                    "attorneyPhoneNumber",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficerCreate;
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: ["requestLicense", "cancelLicense", "transferLicense", "changeLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    if (common.disabled !== true) {
                        common.disabled = viewOnly || !modelRef.isAttorney;
                    }
                } else if(!modelRef.isOfficerCreate) {
                    common.disabled = true;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    // "totalForeignWorkers",
                    "foreignMaleWorkers",
                    "foreignFemaleWorkers",
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: ["requestLicense", "cancelLicense", "transferLicense", "changeLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly || !modelRef.isForeignWorkers;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "thaiMaleWorkers",
                    "thaiFemaleWorkers",
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: ["requestLicense", "cancelLicense", "transferLicense", "changeLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly || !modelRef.isThaiWorkers;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refOriginal",
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef }) => {
                return { disabled: modelRef.id != null };
            }
        },
        // Control:
        //     |-> case1 : role and department or parent of user
        //     |-> case2 :
        {
            check: ({ field }) => {
                return ["forReviewRequest"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let visible = false;
                if (!["draft", undefined].includes(modelRef.refStatus?.key)) {
                    visible = true || visible;
                }
                return visible ;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["draft",  "waitModify", "waitRDAudit", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", ""],
                disabledRequestTypes: []
            }),
        },
        {
            check: ({ field }) => {
                return [
                    "expireDateToEdit",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refFisheriesOfficerStatus?.key === "disagree" ;
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitModify", "waitLawyerAudit", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: ["requestLicense", "cancelLicense", "transferLicense", "changeLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly || modelRef.refFisheriesOfficerStatus?.key !== "disagree";
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refFisheriesOfficerStatus",
                    "attachmentReviewRequests"
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: ["requestLicense", "cancelLicense", "transferLicense", "changeLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "isFisheriesOfficerRemark",   "isFisheriesOfficerRemark2",
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly || modelRef.refFisheriesOfficerStatus?.key != 'disagree';
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "fisheriesOfficerRemark",
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly || !modelRef.isFisheriesOfficerRemark;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "fisheriesOfficerRemark2",
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: ["requestLicense", "cancelLicense", "transferLicense", "changeLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly || !modelRef.isFisheriesOfficerRemark2;
                }
                return common;
            }
        },
        // {
        //     check: ({ field }) => {
        //         return ["forLawyerAuditor"].includes(field?.key);
        //     },
        //     visibleField: ({ props, modelRef }) => {
        //         const { menuContext } = props;
        //         let visible = false;
        //         if (has({ menuContext, key: "forLawyerAuditor" })) {
        //             if (["waitLawyerAudit"].includes(modelRef.refStatus?.key)) {
        //                 visible = true || visible;
        //             }
        //         }
        //         if (have({ menuContext, keys: ["forDofCenter", "forAuthorized"]})){
        //             visible = true || visible;
        //         }
        //         return visible;
        //     },
        // },
        /* For Lawyer */
        {
            check: ({ field }) => {
                return [
                    "forLawyerAuditor",
                    "refLawyerStatus",
                    "lawyerRemark",
                    "attachmentLawyers"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let visible = false;
                if (![undefined, "draft", "waitAcceptRequest", "waitModify"].includes(modelRef.refStatus?.key)) {
                    visible = true || visible;
                }
                return visible ;
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitAcceptRequest", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: ["requestLicense", "cancelLicense", "transferLicense", "changeLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "inspectionApplicant",
                    "inspectionVessel"
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitAcceptRequest", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: ["requestLicense", "cancelLicense", "transferLicense", "changeLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly;
                }
                return common;
            }
        },
        /* For Argue Lawyer */
        {
            check: ({ field }) => {
                return [
                    "argueLawyer",
                    "refArgueLawyerStatus",
                    "argueLawyerRemark",
                    "attachmentArgueLawyers"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let visible = false;
                if (![undefined, "draft", "waitAcceptRequest", "waitModify", "waitRDAudit"].includes(modelRef.refStatus?.key)) {
                    visible = true || visible;
                }
                return visible ;
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitAcceptRequest", "waitLawyerAudit",  "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: ["requestLicense", "cancelLicense", "transferLicense", "changeLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly;
                }
                return common;
            }
        },
        /* For Dof Center */
        {
            check: ({ field }) => {
                return [
                    "dofCenterConsider",
                    "refDofCenterStatus",
                    "dofCenterRemark",
                    "attachmentDofCenters"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let visible = false;
                if (![undefined, "draft", "waitAcceptRequest", "waitModify", "waitRDAudit", "waitLawyerAudit", "waitArgueLawyer"].includes(modelRef.refStatus?.key)) {
                    visible = true || visible;
                }
                return visible;
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitAcceptRequest", "waitLawyerAudit", "waitArgueLawyer", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: ["requestLicense", "cancelLicense", "transferLicense", "changeLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly;
                }
                return common;
            }
        },
        /* For Director */
        {
            check: ({ field }) => {
                return ["directorConsider"].includes(field?.key);
            },
            visibleField: ({  modelRef }) => {
                let visible = false;
                if (![undefined, "draft", "waitAcceptRequest", "waitModify", "waitRDAudit", "waitLawyerAudit",  "waitArgueLawyer", "waitDofCenterAudit"].includes(modelRef.refStatus?.key)) {
                    visible = true || visible;
                }
                return visible;
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refDirectorStatus",
                    "directorRemark",
                    "attachmentDirectors"
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly, menuContext } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitAcceptRequest", "waitLawyerAudit", "waitDofCenterAudit", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["requestLicense", "cancelLicense", "transferLicense", "changeLicense", "requestReplacement"],
                })({ modelRef, initialModel });
                if (!has({ menuContext, key: "forAuthorized"})) {
                    common.disabled = true;
                }
                else if (common.disabled !== true) {
                    common.disabled = viewOnly;
                }
                return common;
            }
        },
        /* For Appeal สำหรับผู้ยื่นคำขอและสิทธิ์อธิบดี */
        {
            check: ({ field }) => {
                return [
                    "appealRequestDetail",
                    "refAppealRequestStatus",
                    "appealRequestRemark",
                    "attachmentAppealRequests",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let visible = false;
                if (modelRef?.refStatus?.key == "notApprove" || modelRef.isHaveAppealedRequest) {
                    visible = true || visible;
                }
                return visible ;
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitAcceptRequest", "waitLawyerAudit",  "waitDofCenterAudit", "waitApprove", "approve", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (!modelRef.isCanAppealRequest) {
                    common.disabled = true;
                } else if (common.disabled !== true && modelRef.isCanAppealRequest) {
                    common.disabled = false;
                }
                common.disabled = common.disabled || modelRef.createBy !== store.state.resource.auth.info.user?.username
                return common;
            }
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("licenseRequestInspections.") &&
                    (field?.key?.endsWith(".isResult"))
                );
            },
            visibleField: ({ modelRef }) => {
                let visible = false;
                if (![undefined, "draft", "waitAcceptRequest", "waitModify"].includes(modelRef.refStatus?.key)) {
                    visible = true || visible;
                }
                return visible ;
            },
            checkedProp: ({ props, items, item, modelRef, initialModel }) => {
                const { viewOnly } = props;
                let enabled = false;
                let onUpdateCheck = undefined;
                const attribute = item.refInspectionTopic?.attribute;
                let otherCheckInGroup = false;
                if (attribute?.checkGroup) {
                    otherCheckInGroup = items.find(d =>
                        d.refInspectionTopic.id !== item.refInspectionTopic.id &&
                        d.refInspectionTopic.attribute?.checkGroup === attribute?.checkGroup &&
                        d.isResult
                    )
                }

                let parentIsChecked = true
                if (item?.refParent) {
                    parentIsChecked = items.find(d =>
                        d.id === item?.refParent?.id &&
                        d.isResult
                    )
                }

                enabled = ( item.refInspectionTopic.attribute?.canCheck &&
                    !viewOnly && !otherCheckInGroup && !!parentIsChecked
                ) || enabled;
                const common = commonInputPropField({
                    disabledStatuses: [undefined, "draft", "waitModify", "waitAcceptRequest", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: ["requestLicense", "cancelLicense", "transferLicense", "changeLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly || !enabled;
                }
                onUpdateCheck = checked => {
                    item.isSave = true;
                    item.isResult = checked;
                    if (!checked) {
                        let childrenInspection = items.filter(d => {
                            return item.children?.map(d => d.id).includes(d?.id)
                        })
                        childrenInspection.forEach(d => {
                            d.isSave = true;
                            d.isResult = false
                        })
                    }
                }
                return { ...common, "onUpdate:checked": onUpdateCheck };
            },
        },
    ]
};
